/***
 * Import statements required for Logger
 */
import { Injectable, Provider } from '@angular/core';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
/***
 * Class that is injectable for performing Logger operations
 */
@Injectable(
    {providedIn: 'root'}
)
export class Logger {
    /***
     * This method is used to get Log under DEBUG category
     */
    get debug() {
        if (window['MIN_LOG_LEVEL'] === 'DEBUG') {
            return console.debug.bind(console);
        } else {
            return () => { };
        }
    }

    /***
     * This method is used to get Log under INFO category
     */
    get info() {
        if (window['MIN_LOG_LEVEL'] === 'DEBUG' || window['MIN_LOG_LEVEL'] === 'INFO') {
            return console.info.bind(console);
        } else {
            return () => { };
        }
    }

    /***
     * This method is used to get Log under LOG category
     */
    get log() {
        if (window['MIN_LOG_LEVEL'] === 'DEBUG' || window['MIN_LOG_LEVEL'] === 'INFO'
            || window['MIN_LOG_LEVEL'] === 'LOG') {
            return console.log.bind(console);
        } else {
            return () => { };
        }
    }

    /***
     * This method is used to get Log under WARN category
     */
    get warn() {
        if (window['MIN_LOG_LEVEL'] === 'DEBUG' || window['MIN_LOG_LEVEL'] === 'INFO'
            || window['MIN_LOG_LEVEL'] === 'LOG' || window['MIN_LOG_LEVEL'] === 'WARN') {
            return console.warn.bind(console);
        } else {
            return () => { };
        }
    }

    /***
     * This method is used to get Log under ERROR category
     */
    get error() {
        if (window['MIN_LOG_LEVEL'] === 'DEBUG' || window['MIN_LOG_LEVEL'] === 'INFO'
            || window['MIN_LOG_LEVEL'] === 'LOG' || window['MIN_LOG_LEVEL'] === 'WARN'
            || window['MIN_LOG_LEVEL'] === 'ERROR') {
            return console.error.bind(console);
        } else {
            return () => { };
        }
    }

    /***
     * This method is used to get Log for Group Start
     */
    get group() {
        return console.group.bind(console);
    }

    /***
     * This method is used to get Log for Group End
     */
    get groupEnd() {
        return console.groupEnd.bind(console);
    }

    constructor(private readonly environment: EnvironmentConfiguration) {
        window['MIN_LOG_LEVEL'] = this.environment.MIN_LOG_LEVEL;
    }
}

// Logging Providers
export var LOGGING_PROVIDERS: Provider[] = [
    //   provide(Logger, {useClass: Logger}),
    {
        'provide': Logger, useClass: Logger
    }
];
